import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="empty-state" style={{ padding: '4rem 1rem' }}>
      <h1>404</h1>
      <p>La pagina solicitada no existe.</p>
      <Link to="/" className="btn btn-primary">
        Volver al panel
      </Link>
    </div>
  );
}
